module.exports = __webpack_public_path__ + "img/the-netherlands-genitourinary-diseases-male.91ec0e59.png";